import posthog from 'posthog-js';
import { POSTHOG_SESSION_ID_HEADER } from '@erp/shared-utils';

export function getPosthogSessionId(): string | undefined {
  try {
    const sessionId = posthog.get_session_id();
    if (typeof sessionId !== 'string') {
      return undefined;
    }
    const trimmed = sessionId.trim();
    return trimmed.length ? trimmed : undefined;
  } catch {
    return undefined;
  }
}

export function buildPosthogHeaders(existing?: HeadersInit): Headers {
  const headers = new Headers(existing);
  const sessionId = getPosthogSessionId();
  if (sessionId) {
    headers.set(POSTHOG_SESSION_ID_HEADER, sessionId);
  }
  return headers;
}
